import spacing from 'theme/config/spacing'

export default {
  root: {
    borderRadius: '1.6rem',
    overflow: 'hidden',
    padding: '0 !important',
  },
};
